/**
 * SectionHeader — eyebrow + heading + optional subtitle, used to introduce a
 * section of blocks. Tokens + Tailwind only.
 */
import type { ReactNode } from 'react';

export interface SectionHeaderProps {
  readonly eyebrow?: string;
  readonly title: ReactNode;
  readonly subtitle?: ReactNode;
  readonly align?: 'left' | 'center';
}

/** `*word*` → editorial italic emphasis (Instrument Serif, accent) — deck-consistent. */
const editorialize = (text: string): string =>
  text.replace(/\*([^*]+)\*/g, '<em class="font-editorial font-normal text-primary">$1</em>');

export function SectionHeader({ eyebrow, title, subtitle, align = 'left' }: SectionHeaderProps) {
  return (
    <header className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      {eyebrow && (
        <p className="mb-3 font-mono text-sm uppercase tracking-wider text-primary">{eyebrow}</p>
      )}
      <h2 className="font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
        {typeof title === 'string'
          ? <span dangerouslySetInnerHTML={{ __html: editorialize(title) }} />
          : title}
      </h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-muted-foreground">{subtitle}</p>}
    </header>
  );
}
